import Joi from 'joi';
import blockAppearanceSchema from '@utils/validate/blocksSchemes/blockAppearanceSchema';
import linkSchema from '@utils/validate/blocksSchemes//linkSchema';
const wysiwygSchema = Joi.object({
  type: Joi.string().valid('wysiwyg').required(),
  code: Joi.string().allow('', null).required(),
  description: Joi.string().allow('', null),
  button: Joi.allow(null),
  additionalButton: Joi.object({
    additionalText: Joi.string(),
    additionalButtonText: Joi.string().allow('', null),
    additionalButtonLink: linkSchema.required(),
    additionalButtonStyle: Joi.string().allow('', null)
  }).allow(null),
  ...blockAppearanceSchema
}).unknown(true);
export default wysiwygSchema;